import { NodeType } from "../types/index.mjs";
import { isValidElement } from "../utils/isValidReactElement.mjs";
const getNodeType = (content) => {
  if (typeof content === "string") {
    return NodeType.Text;
  }
  if (typeof content?.nodeType === "string") {
    return content.nodeType;
  }
  if (Array.isArray(content)) {
    return NodeType.Array;
  }
  if (isValidElement(content)) {
    return NodeType.ReactNode;
  }
  if (typeof content === "number") {
    return NodeType.Number;
  }
  if (typeof content === "boolean") {
    return NodeType.Boolean;
  }
  if (content && typeof content === "object") {
    return NodeType.Object;
  }
  return NodeType.Unknown;
};
export {
  getNodeType
};
//# sourceMappingURL=getNodeType.mjs.map